"use client"

import { useQuery } from "@tanstack/react-query"

import { financeQueryKeys } from "@/features/finance/services/finance-query-keys"
import {
  useFinanceOverviewPeriod,
  useFinanceOverviewScope,
} from "@/features/finance/overview/context/finance-overview-context"
import { fetchChurchFinance } from "@/features/finance/overview/church-f3/services/church-finance-api"

/**
 * The church-wide board's own figures for the board's period. Every F3 tile that needs them reads this one hook,
 * so React Query makes one request. Disabled while `enabled` is false: a reader the absolutes are withheld from
 * never asks (the tiles that need these figures are not even on that reader's board).
 */
export function useChurchFinanceQuery(options: { enabled: boolean; period?: { from: string; to: string } }) {
  const scope = useFinanceOverviewScope()
  const boardPeriod = useFinanceOverviewPeriod()
  const period = options.period ?? boardPeriod
  const dateFrom = period.from ?? ""
  const dateTo = period.to ?? ""

  return useQuery({
    queryKey: financeQueryKeys.churchOverview({ workspaceId: scope.workspaceId, dateFrom, dateTo }),
    queryFn: () => fetchChurchFinance({ workspaceId: scope.workspaceId ?? "", dateFrom, dateTo }),
    enabled: options.enabled && Boolean(scope.workspaceId) && Boolean(dateFrom && dateTo),
    // A refusal (403) will be refused again.
    retry: false,
  })
}
